import React, { FC } from "react";
import PricingSubTable from "./PricingSubTable";

interface PricingTableProps {
    growthPrice: string;
    scalePrice: string;
    proPrice: string;
}

interface TableInternalContentProps {
    title: string;
    growth: string;
    scale: string;
    pro: string;
    growthTooltip?: string;
    scaleTooltip?: string;
    proTooltip?: string;
    tooltip?: any;
}

interface PricingTableDataProps {
    tableTitle: string;
    tableInternalContent: TableInternalContentProps[];
}

const PricingTableData: PricingTableDataProps[] = [
    {
        tableTitle: "Basics",
        tableInternalContent: [
            {
                title: "No. of Users",
                tooltip: "The maximum number of users available in a plan",
                growth: "Up to 6 Users",
                scale: "Up to 6 Users",
                pro: "Up to 6 Users",
            },
            {
                title: "Shared Team Inbox",
                tooltip: "Collaborate seamlessly with your team by accessing a shared inbox where all team members can view and respond to messages in one central location",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Canned response",
                tooltip: "Set a canned response for frequently asked questions or instances like payment reminders, order updates, welcome messages, and more",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Multiple WhatsApp Numbers",
                tooltip: "Adding an additional WhatsApp API number to your account",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Mobile App - Android and IOS",
                tooltip: "Seamlessly respond to your customers via Mobile App",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Custom Fields",
                tooltip: "Create and store data in customized field names based on your business requirement. E.g., PAN, GST No",
                growth: "5",
                scale: "10",
                pro: "15",
            },

            {
                title: "AI Rewrite",
                tooltip: "Rewrite messages to make them more clear, concise, or engaging using Gallabox GPT",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Custom Roles",
                tooltip: "Create roles with customized permissions as per your requirements",
                growth: "no.png",
                scale: "3",
                pro: "6",
            },
            {
                title: "User Teams",
                tooltip: "Create teams with your users to efficiently manage conversations.",
                growth: "no.png",
                scale: "3",
                pro: "5",
            },
        ],
    },
    {
        tableTitle: "Marketing",
        tableInternalContent: [
            {
                title: "Bulk Broadcast Campaigns",
                tooltip: "Send a single template to a large group of recipients instantaneously in a single click",
                growth: "Via Segments",
                scale: "Via Segments and Excel",
                pro: "Via Segments, Excel and API",
            },

            {
                title: "Broadcast Limit",
                tooltip: "Based on Meta’s message limit per day",
                growth: "10,000 / day",
                scale: "100,000 / day",
                pro: "Unlimited",
            },
            {
                title: "Opt-in Management",
                tooltip: "Get consent to communicate or send marketing materials to your customers",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Drip Marketing (Sequence)",
                tooltip: "Send automated messages at regular intervals, such as daily, weekly, or monthly",
                growth: "no.png",
                scale: "10 Campaigns",
                pro: "20 Campaigns",
            },

            {
                title: "CTWA (Facebook Ad Tracking)",
                tooltip: "Track your click-to-WhatsApp-Ads (CTWA) inside Gallabox",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },

            {
                title: "Reply to Config",
                tooltip: "Assign to agent, bot or team",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Message Tracker",
                tooltip: "Track your button clicks on template messages",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
        ],
    },
    {
        tableTitle: "Chatbot",
        tableInternalContent: [
            {
                title: "Bots ",
                tooltip: "Create a custom WhatsApp Chatbot with drag-and-drop tools",
                growth: "3 Bots",
                scale: "5 Bots",
                pro: "10 Bots",
            },
            {
                title: "Multi-lingual Chatbot",
                tooltip: "Interact with your customers in their native language using our multi-lingual chatbot",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },

            {
                title: "Bot Connectors",
                tooltip: "Connect your existing tools with the Gallabox Bot",
                growth: "Starter",
                growthTooltip: "Google sheet, Razorpay, Shopify, Zoho Bigin IN, WooCommerce, Sangam CRM, Zoho Bigin COM, PhonePe",
                scale: "Basic",
                scaleTooltip: "API call, Zoho CRM IN, HubSpot, Zoho CRM COM, Zoom",
                pro: "Advanced",
                proTooltip: "LeadSquared, Open AI, Stripe, Elevenlabs",
            },
            {
                title: "Bot Actions",
                tooltip: "Assign a conversation to a specific team or individual using Chatbots",
                growth: "Starter",
                growthTooltip: "Assign, Unassign, Resolve, Update conversation fields, Update contact & Company fields",
                scale: "Basic",
                scaleTooltip: "Push to Sequence, Add Note & Mention",
                pro: "Coming soon",
            },
            {
                title: "Bot Utilities",
                tooltip: "Set delay, conditions, jump to and switch flows.",
                growth: "Starter",
                growthTooltip: "Send button option, list option, Condition, Set variable, Hint",
                scale: "Basic",
                scaleTooltip: "Delay, Jump to, Switch, Office Hours",
                pro: "Advanced",
                proTooltip: "GPT Dialog, GPT Knowledge",
            },
            {
                title: "Open AI Connector (ChatGPT)",
                tooltip: "Integrate with Open AI to unlock the power AI-driven conversations",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
        ],
    },

    {
        tableTitle: "Commerce",
        tableInternalContent: [
            {
                title: "WhatsApp Shop",
                tooltip: "Connect your e-commerce store to WhatsApp and start selling in no time",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },

            {
                title: "Payment Links",
                tooltip: "Send payment links to customers on the go",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
        ],
    },
    {
        tableTitle: "Analytics",
        tableInternalContent: [
            {
                title: "Conversational Analytics",
                tooltip: "Collect, analyse, and interpret data from your WhatsApp conversations",
                growth: "Basic",
                scale: "Advanced",
                pro: "Advanced",
            },

            {
                title: "Campaign Analytics",
                tooltip: "Measure the effectiveness of your campaigns with data-driven insights",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },

            {
                title: "Bot Analytics",
                tooltip: "Understand bot performance, identify trends, and make improvements",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
        ],
    },
    {
        tableTitle: "API & Webhooks",
        tableInternalContent: [
            {
                title: "API Capabilities",
                tooltip: "Sync seamlessly with your third-party tools",
                growth: "Basic",
                growthTooltip: "Message API, Contact API",
                scale: "Advanced",
                scaleTooltip: "Webhook, Broadcast API, Template API",
                pro: "Advanced",
                proTooltip: "Webhook, Broadcast API, Template API",
            },
            {
                title: "Webhooks",
                tooltip: "Facilitate data exchange between Gallabox and a platform of your choice",
                growth: "Basic",
                growthTooltip: "Contact",
                scale: "Intermediate",
                scaleTooltip: "Message, WA.Stat, Conversation",
                pro: "Advanced",
                proTooltip: "Message Received , Template",
            },
            {
                title: "API Calls / Minute",
                tooltip: "The number of API calls or requests that can be made over a minute",
                growth: "200",
                scale: "500",
                pro: "1000",
            },
        ],
    },
    {
        tableTitle: "Integrations",
        tableInternalContent: [
            {
                title: "Shopify",
                tooltip: "Connect Shopify to share order updates such as created, fulfilled, abandoned, and delivered",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "WooCommerce",
                tooltip:
                    "Send WooCommerce order status alerts and notes to customers on WhatsApp for pending, completed, cancelled, and refund processed along with custom workflows",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Zoho CRM",
                tooltip: "Get a single source of truth with a seamless two-way sync between Gallabox and Zoho CRM",
                growth: "Basic",
                scale: "Advanced",
                pro: "Advanced",
            },
            {
                title: "HubSpot",
                tooltip: "Engage your HubSpot contacts better with streamlined WhatsApp workflows",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "LeadSquared",
                tooltip: "Engage with your LeadSquared CRM leads and customers on WhatsApp",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "Kylas",
                tooltip: "Engage with your Kylas leads and customers on WhatsApp",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Sangam",
                tooltip: "Extend your Sangam CRM’s functionality by engaging with your leads on WhatsApp",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Google Sheet",
                tooltip: "Send or fetch data from Google sheet",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Odoo",
                tooltip: "Automatically trigger WhatsApp messages for Sales Order/Quotations, Proforma Invoice & Delivery slip",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "Razorpay",
                tooltip: "Automatically trigger WhatsApp messages for Payment captured , failed & refund processed",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "CashFree",
                tooltip: "Automatically trigger WhatsApp messages for Payment Success & failed",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "PayU",
                tooltip: "Automatically trigger WhatsApp messages for Payment captured, failed & refund processed",
                growth: "no.png",
                scale: "no.png",
                pro: "Coming soon",
            },
            {
                title: "FB Leads",
                tooltip: "Connect your FB Lead forms to Gallabox & trigger message instantly",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "WebEngage",
                tooltip: "Send targeted broadcast messages without leaving WebEngage",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "MoEngage",
                tooltip: "Send personalised broadcast messages without leaving MoEngage",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "Pabbly",
                tooltip: "Connect with more than 1,000+ apps easily. Just select the app and you’re good to go",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Zapier",
                tooltip: "Collect payments, book appointments, send discount alerts, and update the lead status automatically via Zapier",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Calendly",
                tooltip: "Automate your appointment reminders & reschedule notifications via WhatsApp ",
                growth: "no.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Zoho Books",
                tooltip: "Send personalised  WhatsApp messages for Sales Order/Quotations & Proforma Invoice",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "Shiprocket",
                tooltip: "Share real-time order status instantly (Shipped, Picked Up, Out for Delivery, Delivered, and Rescheduled)",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            // {
            //     title: "Shyplite",
            //     tooltip: "text",
            //     growth: "no.png",
            //     scale: "Coming soon",
            //     pro: "Coming soon",
            // },
            {
                title: "Shipway",
                tooltip: "Share real-time order status instantly (Picked up, Out for delivery, Delivered)",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            // {
            //     title: "Generic webhooks",
            //     tooltip: "Integrate your third-party systems to Gallabox using Generic Webhooks",
            //     growth: "no.png",
            //     scale: "Basic",
            //     pro: "Advanced",
            // },
            {
                title: "Shopflo",
                tooltip: " Send automated WhatsApp triggers for abandoned carts.",
                growth: "yes.png",
                scale: "yes.png",
                pro: "yes.png",
            },
            {
                title: "CleverTap",
                tooltip: " Send personalized WhatsApp campaigns, track stats, and automate workflows",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "Stripe",
                tooltip: "Automatically trigger WhatsApp messages for Payment captured, failed & refund processed",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
            {
                title: "Custom Integration",
                tooltip: "Can’t find a direct connection for your favourite app? We’ll happily create one for you!",
                growth: "no.png",
                scale: "no.png",
                pro: "yes.png",
            },
        ],
    },
];

const PricingTable: FC<PricingTableProps> = ({ growthPrice, scalePrice, proPrice }) => {
    return (
        <div className="pricing-table-section bg-zircon" style={{ maxWidth: "1166px", margin: "auto" }}>
            <div style={{ top: "67px" }} className="bg-gray-200 hidden pricing-table-outer-sticky lg:flex flex-row none md: pricing-table border-gray-200 border border-solid z-3">
                <div className="w-1/4">
                    <p className=" text-3xl font-medium pt-2">Plan Comparison</p>
                    <p className=" text-lg text-gray-700 pt-2">Find your best subscription.</p>
                </div>
                <Stickyheadertitle plan={"Growth"} amount={growthPrice} />
                <Stickyheadertitle plan={"Scale"} amount={scalePrice} />
                <Stickyheadertitle plan={"Pro"} amount={proPrice} />
            </div>

            {PricingTableData.map((data) => {
                return (
                    <PricingSubTable
                        key={data.tableTitle}
                        growthPrice={growthPrice}
                        scalePrice={scalePrice}
                        tableTitle={data.tableTitle}
                        proPrice={proPrice}
                        tableInternalData={data.tableInternalContent}
                    />
                );
            })}
        </div>
    );
};
interface stickyheadertitleProps {
    plan: string;
    amount: string | undefined;
}
export const Stickyheadertitle: FC<stickyheadertitleProps> = ({ plan, amount }) => {
    return (
        <div className="sticky-header sticky top-0 gap-2 lg:w-1/4">
            <p className="text-sm font-medium mt-1.5 text-gray-700">{plan}</p>
            <p className="text-xl font-bold">{amount}</p>
            <div className="pb-1.5">
                <a className="try-btn " href="https://app.gallabox.com/signup" style={{ color: "white", outline: "none", background: "#3182CE" }}>
                    Try for free
                </a>
            </div>
        </div>
    );
};

export default PricingTable;
